export { default as NbModal } from './NbModal';
export type { ModalProps as NbModalProps } from './types';
